<div class="img-crop" [ngStyle]="dynamicStyles" [ngClass]="{
  'img-crop--has-img': src
}">
  <input type="file" class="img-crop__input" #input accept="image/*" (change)="onFileChange($event)">
  <div class="img-crop__cropper"
       *ngIf="showImgCropper"
  >
    <div class="img-crop__cropper-bg" (click)="cancelEdit()"></div>

    <div class="img-crop__img-crop-wrapper">
      <div class="d-flex justify-content-between">
        <div></div>
        <app-button class="img-crop__close-icon-btn" buttonStyle="unstyled" (click)="cancelEdit()">
          <app-icon [name]="ICONS.CLOSE"></app-icon>
        </app-button>
      </div>
      <image-cropper
        #imageCropper
        class="img-crop__img-crop"
        [aspectRatio]="aspectRatio"
        [imageChangedEvent]="imgChangeEvt"
        [maintainAspectRatio]="aspectRatio !== undefined"
        format="png"
        (imageCropped)="imageCropped($event)">
      </image-cropper>

      <div class="img-crop__actions">
        <app-button buttonStyle="white-outlined" (click)="cancelEdit()">{{ 'cancel' | t }}</app-button>
        <app-button buttonStyle="action" (click)="showCropImg()">{{ 'save_changes' | t }}</app-button>
      </div>
    </div>
  </div>
  <ng-container>
    <img *ngIf="src" [src]="src" alt="" class="img-crop__img">

    <button (click)="onUploadImgClick()" type="button" class="img-crop__upload-button">
      <div class="img-crop__upload-icon">
        <app-icon [name]="ICONS.UPLOAD_CLOUD"></app-icon>
      </div>

      <div>
        <span class="img-crop__call-to-action text-medium">{{ 'img_crop_click_to_upload' | t }}</span>

        <span class="text-medium text-color-light">{{ 'img_crop_drag_and_drop' | t }}</span>
      </div>

      <div class="text-medium text-color-light">{{ 'img_crop_formats' | t }}</div>
    </button>
  </ng-container>
</div>
